import React from 'react'
import { useQuery } from '@apollo/client'
import { useParams } from 'react-router-dom'

import { GET_EMPLOYEE, GET_EMPLOYEE_WITH_SAID } from '../infra/queries'
import { usePermissions } from '../infra/permissions'

import { LoadingSpinner } from '../presentation/spinners'
import PersonView from '../presentation/PersonView'

const PersonContainer = () => {
  const { id } = useParams()
  const { canSeeSAID } = usePermissions()

  const { loading, error, data } = useQuery(canSeeSAID ? GET_EMPLOYEE_WITH_SAID : GET_EMPLOYEE, { variables: { id } })

  if (loading) return <LoadingSpinner />
  if (error) throw error

  return <PersonView employee={data.employee} />
}

export default PersonContainer
